export default __webpack_public_path__ + "e7b8669.png";